import MonetaryUtils from "../../../shared/utils/MonetaryUtils";
import { hasValue } from "../../utils/pacto-rebates-utils";
import { isValidPercentageNumber } from "./admin-utils";

export const formatLatePaymentPenaltyPayload = ({
	delinquencyGreaterThan,
	penalty
}) => {
	return {
		percentualInadimplencia: MonetaryUtils.parseDecimal(delinquencyGreaterThan),
		percentualPenalidade: MonetaryUtils.parseDecimal(penalty)
	};
};

export const formatLatePaymentPenaltyResponse = latePaymentPenalty => ({
	id: latePaymentPenalty.id,
	delinquencyGreaterThan: latePaymentPenalty.percentualInadimplencia,
	penalty: latePaymentPenalty.percentualPenalidade,
	createdAt: latePaymentPenalty.dataCriacao,
	updatedAt: latePaymentPenalty.dataUltimaAtualizacao
});

export const validateLatePaymentPenaltyPayload = values => {
	const errors = {};

	if (!hasValue(values.delinquencyGreaterThan)) {
		errors.delinquencyGreaterThan = "Informe o percentual de inadimplência.";
	} else if (!isValidPercentageNumber(values.delinquencyGreaterThan)) {
		errors.penalty = "O percentual de inadimplência deve ter até 5 casas, sendo até 2 decimais.";
    }

	if (!hasValue(values.penalty)) {
		errors.penalty = "Informe a penalidade.";
	} else if (!isValidPercentageNumber(values.penalty)) {
		errors.penalty = "O percentual de penalidade deve ter até 5 casas, sendo até 2 decimais.";
    } else if (MonetaryUtils.parseDecimal(values.penalty) <= 0) {
        errors.penalty = "O percentual de penalidade deve ser maior que zero.";
    }

	return errors;
};